// extracted by mini-css-extract-plugin
export var fadeIn = "_lj-1";
export var modalContent = "_lj-3";
export var overlay = "_lj-0";
export var popoverContent = "_lj-2";
export var results = "_lj-5";
export var searchInputWrapper = "_lj-4";